<div class="single-period-container" *ngIf="payPeriodsList?.length; else loadingTemplate">
  <div class="flex p-x-1 w-100 flex-between">
    <div class="flex p-x-1" [style.width]="'calc(100% - 130px)'">
      <em class="fa fa-3x fa-caret-left nav-button"
          (click)="navigatePrevious()"
          [class.disabled]="!canNavigateBack"
          [class.text-muted]="!canNavigateBack"
          [tooltip]="canNavigateBack ? ('TOOLTIPS.prev_period' | translate) : ''">
      </em>
      <div class="payperiod-list m-x-1" role="group" #payPeriodList>
        <button class="btn btn-period" *ngFor="let payPeriod of payPeriodsList"
                (click)="navigateTo(payPeriod.id)"
                [class.active]="payPeriod.id === editedPayPeriod.id">
          <span>{{ payPeriod.attributes.transid }}</span>
        </button>
      </div>
      <em class="fa fa-3x fa-caret-right nav-button"
          (click)="navigateNext()"
          [class.disabled]="!canNavigateForward"
          [class.text-muted]="!canNavigateForward"
          [tooltip]="canNavigateForward ? ('TOOLTIPS.next_period' | translate) : ''">
      </em>
    </div>
    <button type="button" class="btn primary btn-sm btn-bar-xs flex-self-center" (click)="createVariable()"
            *ngIf="!readOnly">
      <em class="fa fa-light fa-plus-circle"></em>
      <span class="hidden-sm-down m-l-sm">{{ 'NOTIFICATIONS.add' | translate }}</span>
    </button>
  </div>
  <div *ngFor="let variables of [recurrentVariables, nonRecurrentVariables]; let i=index;">
    <div *ngIf="i === 1 || isVariablesV2Enabled" class="m-t-1 m-x-1 p-t-2">
      <h6 class="h6" *ngIf="isVariablesV2Enabled">
        {{ tableHeader(i) | translate }}
        <em class="fa fa-info-circle opacity-3 text-sm"
            [tooltip]="['PAYROLL_PREPARE.recurring_definition', 'PAYROLL_PREPARE.non_recurring_definition'][i] | translate"></em>
      </h6>
      <table class="text-sm" aria-label="variable_elements">
        <colgroup>
          <col style="width: 5%;">
          <col style="width: 45%;">
          <col style="width: auto;">
          <col style="width: auto;">
          <col style="width: 10%;">
          <col style="width: 10%;">
          <col style="width: auto;">
        </colgroup>
        <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">{{ 'PAYROLL_RESULT.name' | translate }}</th>
          <th scope="col">{{ 'PAYROLL_PREPARE.start_date' | translate }}</th>
          <th scope="col">{{ 'PAYROLL_PREPARE.end_date' | translate }}</th>
          <th scope="col" class="text-center">{{ 'PAYROLL_RESULT.tag.amount' | translate }}</th>
          <th scope="col">{{ 'FORMS.Unit' | translate }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let type of variables | keys | sort">
          <tr class="root" *ngIf="variables[type].length === 1; else expand">
            <td></td>
            <td class="variable-name">
              <div class="flex flex-row flex-between">
                <div>
                  {{ variables[type][0]?.attributes.transId | translate }}
                  <span *ngIf="variables[type][0]?.isNew || variables[type][0]?.modified"
                        [style.margin-left]="'2px'">
                      <em class="fa fa-light fa-asterisk unsaved"></em>
                    </span>
                </div>
                <ng-container
                  *ngTemplateOutlet="commentIcon; context: { variable: variables[type][0] }"></ng-container>
              </div>
            </td>
            <td class="flex flex-row">
              <div>
                {{ (!variables[type][0]?.attributes.isBeginDateLinkedToContract ? variables[type][0]?.attributes.begindate : getContractBeginDate()) | gpDate: {}: (triggerDateChange$|async) }}
              </div>
              <ng-container
                *ngTemplateOutlet="linkedDateTemplate; context: { variable: variables[type][0], isBegin: true }"></ng-container>
            </td>
            <td>
              <div class="flex flex-row">
                <div>
                  {{ (!variables[type][0]?.attributes.isEndDateLinkedToContract ? variables[type][0]?.attributes.enddate : getContractEndDate()) | gpDate: {}: (triggerDateChange$|async) }}
                </div>
                <ng-container
                  *ngTemplateOutlet="dateWarningTemplate; context: { variable: variables[type][0] }"></ng-container>
                <ng-container
                  *ngTemplateOutlet="linkedDateTemplate; context: { variable: variables[type][0], isBegin: false }"></ng-container>
              </div>
            </td>
            <td class="td-input text-right p-r-1">
              <number-input #input
                            [(ngModel)]="variables[type][0]?.attributes.value"
                            (ngModelChange)="markAsDirty(variables[type][0])"
                            [readOnly]="readOnly"
                            [classes]="[readOnly ? 'disabled' : '']"
                            [type]="'decimal'"
                            [maxDigits]="4">
              </number-input>
            </td>
            <td>{{ variables[type][0]?.attributes.unitTransId | translate }}</td>
            <td class="row-actions">
              <ng-container
                *ngTemplateOutlet="controls; context: { variable: variables[type][0], isNested: false, type: type }"></ng-container>
            </td>
          </tr>
          <ng-template #expand>
            <tr class="root">
              <td (click)="toggleExpand(type)">
                    <span class="fa fa-light" [class.fa-caret-right]="!expanded[type]"
                          [class.fa-caret-down]="expanded[type]">
                    </span>
              </td>
              <td>{{ variables[type][0]?.attributes.transId | translate }}</td>
              <td></td>
              <td></td>
              <td class="td-input text-right p-r-1">
                <i class="fa-solid fa-sigma"></i>
                {{ getVariableSum(variables[type]) }}
              </td>
              <td>{{ variables[type][0]?.attributes.unitTransId | translate }}</td>
              <td></td>
            </tr>
            <ng-container *ngIf="expanded[type]">
              <tr *ngFor="let variable of variables[type]">
                <td></td>
                <td class="variable-name">
                  <div class="flex flex-row flex-between">
                    <div>
                      -
                      <span *ngIf="variable?.isNew || variable?.modified"
                            [style.margin-left]="'2px'">
                          <em class="fa fa-light fa-asterisk unsaved"></em>
                        </span>
                    </div>
                    <ng-container
                      *ngTemplateOutlet="commentIcon; context: { variable: variable }"></ng-container>
                  </div>
                </td>
                <td class="flex flex-row">
                  <div>
                    {{ (!variable?.attributes.isBeginDateLinkedToContract ? variable?.attributes.begindate : getContractBeginDate()) | gpDate: {}: (triggerDateChange$|async) }}
                  </div>
                  <ng-container
                    *ngTemplateOutlet="linkedDateTemplate; context: { variable: variable, isBegin: true }"></ng-container>
                </td>
                <td>
                  <div class="flex flex-row relative">
                    {{ (!variable?.attributes.isEndDateLinkedToContract ? variable?.attributes.enddate : getContractEndDate()) | gpDate: {}: (triggerDateChange$|async) }}
                    <ng-container
                      *ngTemplateOutlet="dateWarningTemplate; context: { variable: variable }"></ng-container>
                    <ng-container
                      *ngTemplateOutlet="linkedDateTemplate; context: { variable: variable, isBegin: false }"></ng-container>
                  </div>
                </td>
                <td class="td-input text-right p-r-1">
                  <number-input #input
                                [(ngModel)]="variable?.attributes.value"
                                (ngModelChange)="markAsDirty(variable)"
                                [readOnly]="readOnly"
                                [classes]="[readOnly ? 'disabled' : '']"
                                [type]="'decimal'"
                                [maxDigits]="4">
                  </number-input>
                </td>
                <td>-</td>
                <td class="row-actions">
                  <ng-container
                    *ngTemplateOutlet="controls; context: { variable: variable, isNested: true, type: type }"></ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-template>

        </ng-container>
        <tr *ngIf="(!variables || !objectKeys(variables)?.length) && (!loading && !localLoading)">
          <td colspan="7">
            <div class="font-weight-bold text-center">
              {{ 'PAYROLL_PREPARE.variables_not_found' | translate }}
            </div>
          </td>
        </tr>
        <tr *ngIf="localLoading">
          <td colspan="7">
            <div class="flex flex-center-x-y">
              <em class="fa fa-light fa-spinner fa-spin"></em>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="flex flex-center-x-y">
    <div class="flex-center-x-y">
      <em class="fa fa-light fa-spin fa-spinner">
      </em>
    </div>
  </div>
</ng-template>

<ng-template #controls let-variable="variable" let-nested="isNested" let-type="type">
  <div class="flex flex-center-x-y" *ngIf="!isEmployeeFormEmbedded">
    <div class="flex-center-x-y">
      <em class="actions fa fa-light pointer m-r" [class.fa-pencil-alt]="!readOnly"
          [class.fa-eye]="readOnly && variable?.attributes?.value"
          container="body" [tooltip]="(readOnly ? 'TOOLTIPS.view' : 'TOOLTIPS.edit') | translate"
          aria-hidden="true"
          (click)="editVariable(variable)">
      </em>
    </div>
    <div class="flex-center-x-y" *ngIf="!readOnly">
      <em class="actions fa fa-light fa-trash-alt pointer" container="body"
          tooltip="{{ 'TOOLTIPS.delete' | translate }}" aria-hidden="true"
          (click)="elementDeleted(variable, nested, type)">
      </em>
    </div>
  </div>
</ng-template>

<ng-template #commentIcon let-variable="variable">
  <div *ngIf="variable?.attributes?.comment" class="flex-center wrapper"
       triggers="mouseenter:mouseleave mouseenter:click"
       [popover]="variable?.attributes?.value ? commentTemplate : null"
       container="body">
    <em class="fa fa-light fa-comment m-r"></em>
  </div>
  <ng-template #commentTemplate>
    <div class="flex flex-column">
      <label [style.font-weight]="'bold'">
        {{ 'COMMON.comment' | translate }}:
      </label>
      {{ variable?.attributes.comment }}
    </div>
  </ng-template>
</ng-template>

<ng-template #dateWarningTemplate let-variable="variable">
  <div *ngIf="dateWarning(variable.attributes?.enddate)"
       triggers="mouseenter:mouseleave mouseenter:click"
       [popover]="dateWarningMessage"
       container="body">
    <em class="fa fa-light fa-warning text-warn m-l"></em>
  </div>
  <ng-template #dateWarningMessage>
    <div class="flex flex-column">
      {{ 'PAYROLL_PREPARE.variable_outside_contract_limits' | translate }}
    </div>
  </ng-template>
</ng-template>

<ng-template #linkedDateTemplate let-variable="variable" let-isBegin="isBegin">
  <div
    *ngIf="isBegin ? variable.attributes?.isBeginDateLinkedToContract : variable.attributes?.isEndDateLinkedToContract"
    triggers="mouseenter:mouseleave mouseenter:click"
    [popover]="linkedDateMessage"
    container="body">
    <em class="fa fa-light fa-chain-horizontal m-l"></em>
  </div>
  <ng-template #linkedDateMessage>
    <div class="flex flex-column">
      {{ (isBegin ? 'PAYROLL_PREPARE.linked_to_contract_begindate_popover' : 'PAYROLL_PREPARE.linked_to_contract_enddate_popover') | translate }}
    </div>
  </ng-template>
</ng-template>
